const info = [
    {
        id: "1",
        text: "1343 BC - The Tutankhamun timeline starts in 1343BC when he was born in Amarna, the new capital of Egypt built by his father Pharaoh Akhenaten to replace Thebes. The chief wife of Akhenaten was Nefertiti. The mother of Tutankhamun was another wife of the Pharaoh, called Kiya."
    },
    {
        id: "2",
        text: "1337 BC- The father of Tutankhamun was forced to abdicate due to his belief in a radical new religion he had introduced that worshipped just one god named Aten. The throne of Egypt was taken by Smenkhkare Ankhetkheperure." 
    },
    {
        id: "3",
        text: "1334 BC- At the age of just 9 years old Tutankhamun was made King of Egypt. His regent was called Ay who was also the father of Nefertiti, the stepmother of Tutankhamun." 
    },
    {
        id: "4",
        text: "1334 BC- The third daughter of Akhenaten and Nefertiti, called Ankhesenpaaten, married Tutankhamun (she was therefore his half-sister)." 
    },
    {
        id: "5",
        text: "1331 BC- The boy king was forced to change his name from Tutankhaten to Tutankhamun - this was done to emphasise that the god Amun was more important than the god his father had introduced (Aten)" 
    },
    {
        id: "6",
        text: "1330 BC- The boy king Tutankhamun and his child bride were forced to leave their childhood home of Amarna and relocate in the old capital of Thebes - restoring power to the priests of the god Amun." 
    },
    {
        id: "7",
        text: "1330 BC - 1325 BC - Tutankhamen and his wife had two daughters but they were both stillborn. During this period a military general, Horemheb, was declared heir to the throne. New temples were built in Thebes and Karnak to worship the god Amun" 
    },
    {
        id: "8",
        text: "1325 BC - His short life ended in 1325BC, he was barely 19 years pld. The cause of his death is a mystery. There are speculations that he was murdered, or that he died of an injury sustained in a chariot accident. His wife also mysteriously disappeared shortly after his death." 
    },
    {
        id: "9",
        text: "1324 BC - He was buried in a tomb in the Valley of the Kings. This minor Pharaoh was made the most famous king of all when Harold Carter discovered his tomb, and its wonderful belongings, on 4 November 1922." 
    }
]

export default info
